import {excludeBrand} from '../../themeConfig'

const state = {
    brand: null
}

const mutations = {
    setBrand(state, payload = null) {
        state.brand = excludeBrand.includes(payload) ? null : payload
    }
}

const getters = {
    getBrand: state => state.brand
}

export default {
    state,
    mutations,
    getters
}
